import { Wrap, WrapItem, Avatar, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useApi } from "../../../api"
import { useProjectCode } from "../../../hooks/useProjectCode";
import { ICargo, IChildrenProfile } from "../../../interfaces";
import { Utils } from "../../../utils";

export const TeamPage = () => {
  const projectCode = useProjectCode();
  const api = useApi(projectCode);
  const toast = useToast();
  const [childrens, setChildrens] = useState<IChildrenProfile[]>();

  useEffect(() => {
    if (childrens) return;
    api.getChildrens((cargo: ICargo) => {
      setChildrens(cargo.info);
    })
  }, [api, childrens])

  return (
    <>
      <div className="p-3">
        <Wrap>
          {
            childrens && childrens.map((children, index) => {
              return (
                <WrapItem key={index}>
                  <Avatar
                    className="m-3 cursor-pointer"
                    name={children.nickname}
                    src={children.avator ? Utils().normalizeImagePath(children.avator, projectCode) : require('../../../assets/img/nopic.png')}
                    onClick={() => {
                      toast({
                        title: '暱稱',
                        description: children.nickname,
                        position: 'bottom-right',
                        status: 'success',
                        duration: 9000,
                        isClosable: true,
                      })
                    }}
                  />
                </WrapItem>
              )
            })
          }
        </Wrap>
      </div>
    </>
  )
}